module.exports = __webpack_public_path__ + "img/express-splitter-east.ee066aa8.png";